"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HiddenForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var Form = _styledComponents["default"].form.withConfig({
  displayName: "Form",
  componentId: "sc-e61gml-0"
})(["display:none;"]);

var HiddenForm = function HiddenForm(_ref) {
  var applyUrl = _ref.applyUrl,
      acquisitionOfferId = _ref.acquisitionOfferId,
      acquisitionWebToken = _ref.acquisitionWebToken,
      applicantRequestToken = _ref.applicantRequestToken,
      formId = _ref.formId,
      disableApply = _ref.disableApply;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Form, {
    action: applyUrl,
    id: "hidden_form_".concat(formId),
    method: "post",
    target: "_blank",
    onSubmit: disableApply,
    "data-testid": "creditcardcard:hidden_form",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "hidden",
      name: "acquisition_offer_id",
      value: acquisitionOfferId
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "hidden",
      name: "acquisition_web_token",
      value: acquisitionWebToken
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "hidden",
      name: "applicant_request_token",
      value: applicantRequestToken
    })]
  });
};

exports.HiddenForm = HiddenForm;

var _default = (0, _styledComponents["default"])(HiddenForm).withConfig({
  componentId: "sc-e61gml-1"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=hidden-form.js.map